import { $Button } from "./styles"
export const Button = ({ text, $white, $send }) => {
    return (
        <$Button $white={$white} $send={$send}> {text} </$Button>
    )
}